import type { CSSProperties, ReactNode } from "react";

export function Label({
  children,
  className = "",
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}): ReactNode {
  return (
    <div
      style={style}
      className={`font-mono text-[10px] font-medium uppercase tracking-[0.5px] text-n-500 ${className}`}
    >
      {children}
    </div>
  );
}

export function Kbd({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}): ReactNode {
  return (
    <kbd
      className={`inline-flex h-[18px] min-w-[16px] items-center justify-center rounded-1 border border-b-2 border-n-200 bg-n-75 px-1 font-mono text-[10px] font-medium text-n-600 ${className}`}
    >
      {children}
    </kbd>
  );
}

export function Avatar({
  initials,
  size = 24,
  color,
  bg,
  className = "",
}: {
  initials: string;
  size?: number;
  color?: string;
  bg?: string;
  className?: string;
}): ReactNode {
  return (
    <div
      className={`inline-flex flex-shrink-0 items-center justify-center rounded-full font-semibold tracking-[-0.2px] ${className}`}
      style={{
        width: size,
        height: size,
        background: bg ?? "var(--a-100)",
        color: color ?? "var(--a-500)",
        fontSize: Math.round(size * 0.42),
      }}
    >
      {initials}
    </div>
  );
}

const SEV_COLORS: Record<string, string> = {
  critical: "var(--bad)",
  high: "#d47a14",
  medium: "var(--warn)",
  low: "var(--info)",
  info: "var(--n-400)",
};

export function SevDot({
  sev,
  size = 8,
}: {
  sev: string;
  size?: number;
}): ReactNode {
  const color = SEV_COLORS[sev] ?? "var(--n-400)";
  return (
    <span
      className="inline-block flex-shrink-0 rounded-full"
      style={{
        width: size,
        height: size,
        background: color,
        boxShadow:
          sev === "critical"
            ? `0 0 0 3px var(--bad-bg)`
            : "none",
      }}
    />
  );
}
